import { z } from "zod";
import { MAXIMUM_REPORT_DURATION_SECONDS } from "./reporting-constants.js";
import { videoBrandIdSchema, videoIdSchema } from "./video.js";
export const MAXIMUM_VIDEO_LABEL_FALLBACK_CODE_POINTS = 160;
export const videoLabelInputSchema = z
    .object({
    adCount: z.number().int().nonnegative().max(1_000_000),
    brandId: videoBrandIdSchema,
    displayAdName: z.string().max(10_000).nullable(),
    lengthSeconds: z
        .number()
        .finite()
        .nonnegative()
        .max(MAXIMUM_REPORT_DURATION_SECONDS)
        .nullable(),
    videoId: videoIdSchema,
})
    .strict();
export function videoLabel(input) {
    const value = videoLabelInputSchema.parse({
        adCount: input.adCount,
        brandId: input.brandId,
        displayAdName: input.displayAdName,
        lengthSeconds: input.lengthSeconds,
        videoId: input.videoId,
    });
    const supplied = normalizeLabelText(value.displayAdName ?? "");
    const fallback = normalizeLabelText(`Video ${value.brandId} / ${value.videoId}`);
    const primary = supplied || boundFallback(fallback);
    const duration = value.lengthSeconds === null
        ? "Duration unavailable"
        : formatDuration(value.lengthSeconds);
    const adCount = `${value.adCount} ${value.adCount === 1 ? "ad" : "ads"}`;
    return Object.freeze({
        accessible: `${primary}, ${duration}, ${adCount}`,
        primary,
        secondary: `${duration} · ${adCount}`,
    });
}
function normalizeLabelText(value) {
    return value
        .normalize("NFKC")
        .replace(/[\p{Cc}\p{Cf}\p{Zl}\p{Zp}]+/gu, " ")
        .replace(/\s+/gu, " ")
        .trim();
}
function boundFallback(value) {
    const points = [...value];
    if (points.length <= MAXIMUM_VIDEO_LABEL_FALLBACK_CODE_POINTS)
        return value;
    return `${points
        .slice(0, MAXIMUM_VIDEO_LABEL_FALLBACK_CODE_POINTS - 1)
        .join("")}…`;
}
function formatDuration(seconds) {
    const rounded = Math.round(seconds);
    if (rounded < 60)
        return `${rounded}s`;
    const minutes = Math.floor(rounded / 60);
    const remainder = rounded % 60;
    return remainder === 0 ? `${minutes}m` : `${minutes}m ${remainder}s`;
}
//# sourceMappingURL=video-label.js.map